module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "wide": false,
      "width": "500px"
    },
    on: {
      "close": _vm.localCloseModal
    }
  }, [(_vm.params.title) ? _c('h1', [_vm._v(_vm._s(_vm.params.title))]) : _vm._e(), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.params.content)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [(_vm.params.yes) ? _c('button', {
    staticClass: "small",
    on: {
      "click": function($event) {
        return _vm.params.yes()
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('general.yes')) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.params.ok) ? _c('button', {
    staticClass: "small",
    on: {
      "click": function($event) {
        return _vm.params.ok()
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('general.okay')) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.params.no) ? _c('button', {
    staticClass: "small white border",
    on: {
      "click": function($event) {
        return _vm.params.no()
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('general.no')) + "\n    ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.params.buttons), function(btn) {
    return _c('button', {
      class: btn.class,
      on: {
        "click": function($event) {
          return btn.click()
        }
      }
    }, [_vm._v("\n      " + _vm._s(btn.title) + "\n    ")])
  })], 2), _vm._v(" "), (this.params.embed) ? _c(this.params.embed, {
    tag: "component",
    attrs: {
      "config": this.params
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1b2dde5f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/GeneralModal.vue
// module id = 911
// module chunks = 0